module.exports = __webpack_public_path__ + "img/logo_yourstory.92c2a2d2.svg";